package com.example.event_management_system.data.repository

import dev.gitlive.firebase.functions.FirebaseFunctions
import dev.gitlive.firebase.functions.httpsCallable

class EmailRepository(
    private val functions: FirebaseFunctions
) : IEmailRepository {
    override suspend fun sendEventConfirmation(eventId: String, bodyOverride: String?): Result<Unit> {
        return try {
            val payload = buildMap<String, Any> {
                put("eventId", eventId)
                if (!bodyOverride.isNullOrBlank()) put("bodyOverride", bodyOverride)
            }
            functions.httpsCallable("sendEventConfirmation")(payload)
            Result.success(Unit)
        } catch (e: Throwable) {
            Result.failure(Exception(e.message ?: "Failed to send confirmation email", e))
        }
    }

    override suspend fun sendTestEmail(domain: String, to: String, fromEmail: String?): Result<Unit> {
        return try {
            val payload = buildMap {
                put("domain", domain)
                put("to", to)
                if (!fromEmail.isNullOrBlank()) put("from", fromEmail)
            }
            functions.httpsCallable("sendTestEmail")(payload)
            Result.success(Unit)
        } catch (e: Throwable) {
            Result.failure(Exception(e.message ?: "Failed to send test email", e))
        }
    }

    override suspend fun createTeamMember(
        email: String,
        displayName: String,
        phone: String?,
        role: String,
        locationIds: List<String>
    ): Result<Unit> {
        return try {
            val payload = buildMap<String, Any> {
                put("email", email)
                put("displayName", displayName)
                if (!phone.isNullOrBlank()) put("phone", phone)
                put("role", role)
                put("locationIds", locationIds)
            }
            functions.httpsCallable("createTeamMember")(payload)
            Result.success(Unit)
        } catch (e: Throwable) {
            Result.failure(Exception(e.message ?: "Failed to create team member.", e))
        }
    }

    override suspend fun deleteTeamMember(userId: String): Result<Unit> {
        return try {
            functions.httpsCallable("deleteTeamMember")(mapOf("userId" to userId))
            Result.success(Unit)
        } catch (e: Throwable) {
            Result.failure(Exception(e.message ?: "Failed to delete team member.", e))
        }
    }
}
